var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhotoGalleryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 100,
    viewBox: "0 0 79 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1001"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M68.9521 66.2516C76.904 58.1083 76.904 45.0553 68.9521 36.912C61.1765 28.9265 48.4261 28.7884 40.4938 36.6163C40.3959 36.7149 40.2979 36.8134 40.2 36.912L39.9258 37.2078L39.632 36.912C31.8368 28.9265 19.0864 28.7884 11.1541 36.636C11.0562 36.7346 10.9779 36.8134 10.8799 36.912C2.92805 45.0159 2.92805 58.1477 10.8799 66.2516L39.9062 94.9997L68.9521 66.2516Z",
    fill: "url(#paint0_linear_787_27332)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M39.5 63.333C42.9518 63.333 45.75 60.5348 45.75 57.083C45.75 53.6312 42.9518 50.833 39.5 50.833C36.0482 50.833 33.25 53.6312 33.25 57.083C33.25 60.5348 36.0482 63.333 39.5 63.333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.213 34.8271C66.7273 30.2765 60.5767 27.6985 54.1714 27.718C48.8631 27.6985 43.6918 29.4757 39.5 32.7178C35.5628 29.6515 30.7442 27.9133 25.7492 27.7375V21.5073C25.6513 13.9686 31.7431 7.77744 39.3433 7.67979C46.9435 7.58214 53.1724 13.6366 53.2704 21.1753C53.2704 21.2925 53.2704 21.3901 53.2704 21.5073H60.7726C60.9881 9.8672 51.6446 0.238709 39.9114 0.0043446C28.1781 -0.23002 18.4821 9.04692 18.247 20.7066C18.247 20.98 18.247 21.2534 18.247 21.5073V28.6359C14.2706 29.7687 10.6664 31.8975 7.76742 34.8271C-1.59566 44.2407 -1.59566 59.5916 7.80659 69.0443L39.5 100L71.1738 69.0639L71.213 69.0248C80.5957 59.533 80.5957 44.3188 71.213 34.8271ZM65.8851 63.7711L39.5 89.5512L13.1149 63.7906C6.61172 57.248 6.61172 46.6039 13.1149 40.0612C19.4615 33.6357 29.8431 33.538 36.3072 39.8268C36.3855 39.905 36.4639 39.9831 36.5422 40.0612L39.5 43.0494L42.4578 40.0612C45.5331 36.9363 49.7641 35.1591 54.1714 35.1591C58.5787 35.1591 62.8097 36.9168 65.8851 40.0612C72.3687 46.6429 72.3687 57.1698 65.8851 63.7711Z",
    fill: "url(#paint1_linear_787_27332)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.213 34.8271C66.7273 30.2765 60.5767 27.6985 54.1714 27.718C48.8631 27.6985 43.6918 29.4757 39.5 32.7178C35.5628 29.6515 30.7442 27.9133 25.7492 27.7375V21.5073C25.6513 13.9686 31.7431 7.77744 39.3433 7.67979C46.9435 7.58214 53.1724 13.6366 53.2704 21.1753C53.2704 21.2925 53.2704 21.3901 53.2704 21.5073H60.7726C60.9881 9.8672 51.6446 0.238709 39.9114 0.0043446C28.1781 -0.23002 18.4821 9.04692 18.247 20.7066C18.247 20.98 18.247 21.2534 18.247 21.5073V28.6359C14.2706 29.7687 10.6664 31.8975 7.76742 34.8271C-1.59566 44.2407 -1.59566 59.5916 7.80659 69.0443L39.5 100L71.1738 69.0639L71.213 69.0248C80.5957 59.533 80.5957 44.3188 71.213 34.8271ZM65.8851 63.7711L39.5 89.5512L13.1149 63.7906C6.61172 57.248 6.61172 46.6039 13.1149 40.0612C19.4615 33.6357 29.8431 33.538 36.3072 39.8268C36.3855 39.905 36.4639 39.9831 36.5422 40.0612L39.5 43.0494L42.4578 40.0612C45.5331 36.9363 49.7641 35.1591 54.1714 35.1591C58.5787 35.1591 62.8097 36.9168 65.8851 40.0612C72.3687 46.6429 72.3687 57.1698 65.8851 63.7711Z",
    fill: "url(#paint2_linear_787_27332)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9314 47.5001C34.4151 47.4805 29.9356 51.9627 29.916 57.4822C29.916 61.573 32.3807 65.2527 36.1756 66.7794V75H43.6676V66.7794C48.7731 64.7047 51.2574 58.8915 49.1839 53.7634C47.6777 49.9663 44.0002 47.5001 39.9314 47.5001ZM39.9314 54.9965C41.3203 54.9965 42.4353 56.1121 42.4353 57.5018C42.4353 58.8915 41.3203 60.0072 39.9314 60.0072C38.5426 60.0072 37.4276 58.8915 37.4276 57.5018C37.4471 56.1121 38.5621 54.9965 39.9314 54.9965Z",
    fill: "url(#paint3_linear_787_27332)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9314 47.5001C34.4151 47.4805 29.9356 51.9627 29.916 57.4822C29.916 61.573 32.3807 65.2527 36.1756 66.7794V75H43.6676V66.7794C48.7731 64.7047 51.2574 58.8915 49.1839 53.7634C47.6777 49.9663 44.0002 47.5001 39.9314 47.5001ZM39.9314 54.9965C41.3203 54.9965 42.4353 56.1121 42.4353 57.5018C42.4353 58.8915 41.3203 60.0072 39.9314 60.0072C38.5426 60.0072 37.4276 58.8915 37.4276 57.5018C37.4471 56.1121 38.5621 54.9965 39.9314 54.9965Z",
    fill: "url(#paint4_linear_787_27332)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_787_27332",
    x1: 39.9209,
    y1: 95.0041,
    x2: 39.9209,
    y2: 30.8374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2A4BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDCE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_787_27332",
    x1: 0.754905,
    y1: 50.0043,
    x2: 78.2549,
    y2: 50.0043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F96992"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F96992"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_787_27332",
    x1: 39.5,
    y1: 0,
    x2: 39.5,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4237C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_787_27332",
    x1: 29.9209,
    y1: 61.2544,
    x2: 49.9209,
    y2: 61.2544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F96992"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F96992"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_787_27332",
    x1: 39.916,
    y1: 47.5,
    x2: 39.916,
    y2: 75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4237C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2C6B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoGalleryIcon);
export default __webpack_public_path__ + "static/media/photo-gallery-icon.11fed95fc368a1f173b21dc93e90f77c.svg";
export { ForwardRef as ReactComponent };